import { oz } from '@weft/utils';
import { CommercialTermsPricingInputSchema } from './commercial-terms/commercial-terms-pricing-input-schema';
import { CommissionPricingInputSchema } from './fixed-commission/commission-pricing-input-schema';
import { OneTimePricingInputSchema } from './fixed-one-time/one-time-pricing-input-schema';
import { FixedPerUnitPricingInputSchema } from './fixed-per-unit/fixed-per-unit-pricing-input-schema';
import { InstallmentsPricingInputSchema } from './installments/installments-pricing-input-schema';
import { RefundPricingInputSchema } from './refund/refund-pricing-input-schema';
import { SubscriptionPricingInputSchema } from './subscription/subscription-pricing-input-schema';

export const FixedPricingInputSchema = oz.discriminatedUnion('pricingModel', [
  SubscriptionPricingInputSchema,
  OneTimePricingInputSchema,
  FixedPerUnitPricingInputSchema,
  CommercialTermsPricingInputSchema,
  CommissionPricingInputSchema,
  InstallmentsPricingInputSchema,
  RefundPricingInputSchema,
]).openapi('FixedPricingInput');

export type FixedPricingInput = oz.infer<typeof FixedPricingInputSchema>;